import Script from 'next/script'

const MsClarity: React.FC = () => {
  return process.env.NODE_ENV === 'production' ? (
    <>
      <Script
        type='text/javascript'
        id='ms-clarity'
        strategy='lazyOnload'
        dangerouslySetInnerHTML={{
          __html: `
        (function(c,l,a,r,i,t,y){
          c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "qmkck09993");`,
        }}
      />
    </>
  ) : (
    <></>
  )
}

export default MsClarity
